import React, { useEffect } from "react"
import { useParams, useNavigate } from "react-router-dom"
import { extractEmailFromJWT, formatOtpLoginUrl } from "../utils/jwtUtils"

const SignupRedirect: React.FC = () => {
  const { token } = useParams<{ token: string }>()
  const navigate = useNavigate()

  useEffect(() => {
    if (!token) {
      navigate("/login")
      return
    }

    // Extract email from JWT token
    const email = extractEmailFromJWT(token)

    if (!email) {
      navigate("/login")
      return
    }

    // Redirect to the new OTP login page with email and token
    const otpUrl = formatOtpLoginUrl(email, token)
    window.location.href = otpUrl
  }, [token, navigate])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">Redirecting to login...</p>
      </div>
    </div>
  )
}

export default SignupRedirect
